import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Autoplay, Navigation } from "swiper/modules";

import banner1 from "../../../assests/img/banner1.png";
import banner2 from "../../../assests/img/banner2.png";
import banner4 from "../../../assests/img/banner4.png";
import banner5 from "../../../assests/img/banner5.png";
import banner7 from "../../../assests/img/banner7.png";

import { Card, Col, Row } from "react-bootstrap";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";

class SliderSec extends Component {
  render() {
    return (
      <>
        {/* ================= SLIDER SECTION ================= */}
        <section className="slider_sec">
          <Swiper
            modules={[Autoplay]}
            loop
            autoplay={{
              delay: 3000,
              disable_attach: false,
              pauseOnMouseEnter: true,
            }}
            slidesPerView={1}
            spaceBetween={20}
            breakpoints={{
              320: {
                spaceBetween: 10,
              },
              768: {
                spaceBetween: 15,
              },
              1024: {
                spaceBetween: 20,
              },
            }}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner1}
                  alt="Kior Healthcare diagnostic centre in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner2}
                  alt="Kior Healthcare diagnostic centre in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner4}
                  alt="Advanced imaging and radiology services in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner5}
                  alt="Fully automated pathology lab in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner7}
                  alt="CT scan and X-ray diagnostic services in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </section>

        {/* ================= INTRO TEXT ================= */}
        <section className="home_intro_text">
          <div className="coustom_container">
            <h1>
              Best Diagnostic Centre in Mohali – Advanced & Trusted Diagnostics
              | Kior Healthcare
            </h1>

            {/* <h2>
              Accurate Results • Advanced Technology • Complete Diagnostic Care
            </h2> */}

            <p>
              If you are looking for one of the best diagnostic centre in
              Mohali, then there is no better name than Kior Healthcare that
              promises accuracy, high-risoluting technology and patient-centric
              approach. We are the best diagnostic lab in Mohali. Currently we
              offer diagnostic services to residents of Mohali. We deliver
              effective and reliable results in less than 24 hours.
            </p>

            {/* <p>
              Our mission is to make diagnostics accessible, precise, and
              trustworthy across Punjab.
            </p> */}
          </div>
        </section>

        {/* ================= PATHOLOGY & IMAGING INFO ================= */}
        <section className="service_info">
          <div className="coustom_container">
            <div className="service_block">
              <h2>Advanced Diagnostic Centre Serving Punjab & Tricity</h2>
              <p>
                Kior Healthcare is the most popular diagnostic centre in Punjab,
                serving patients from Chandigarh, Panchkula, and across the
                Tricity region. We are equipped with state-of-the-art medical
                imaging and fully automated laboratory systems to deliver
                accurate testing results. We believe in bringing advanced
                diagnostic solutions right to your home. Kior Healthcare has an
                extensive portfolio of diagnostic tests for MRI, CT Scan,
                Digital X-Ray, Mammography, Ultrasound and Colour Doppler, all
                using the latest technology to give accurate diagnoses.
              </p>
            </div>
            <div className="service_block">
              <h2>NABL-Standard Quality Pathology & Blood Test Centre</h2>

              <p>
                As a quality-driven pathology lab and blood test centre, we
                focus on accuracy, automation, and strict quality control
                processes. Our dedicated, board-certified radiologists and
                related lab professionals provide patients and physicians with
                expert interpretations that adhere to the highest level of
                clinical standards. Our state-of-the-art equipment and automated
                processes allow us to provide fast, accurate diagnostic reports.
              </p>
            </div>

            <div className="service_block">
              <h2>Patient-Focused, Technology-Driven Diagnostic Care</h2>
              <p>
                Kior Healthcare, We create health and well-being through
                patient-centred care delivered with knowledge, empathy and love.
                We want to be the trusted diagnostic centre near Chandigarh that
                people turn to, while also being the popular diagnostic
                centre to visit from Panchkula and Tricity. We continuously
                upgrade our technology and processes to provide safe, efficient,
                and comfortable diagnostic experiences. If you are searching for
                an imaging centre in Mohali providing trustworthy and accurate
                Diagnostic Imaging & Pathology services under one roof, the
                search ends at Kior Healthcare.
              </p>
            </div>

            <div className="service_cta">
              <h3>Book Your Test Today</h3>

              <p>
                Choose Kior Healthcare — your trusted diagnostic centre in
                Punjab, with a state-of-the-art pathology lab in Mohali and a
                modern imaging center for X-Ray, CT Scan, and more.
              </p>

              <p className="cta_links">
                <a href="tel:+91 8263000004">Call Now</a>
                <span className="divider"> | </span>

                <a
                  href="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book Online
                </a>
                <span className="divider"> | </span>

                <a href="/contact-us">Visit Our Centre</a>
              </p>

              <p className="cta_note">
                Your health begins with accurate diagnosis — we are here to
                support you at every step.
              </p>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default SliderSec;
